__webpack_require__.p = "/typescript-practice/";